import { IAction } from '@Root/types'

export const ExternalTokenActionTypes = {
  FETCH_EXTERNAL_TOKENS: '@@externalToken/FETCH_EXTERNAL_TOKENS',
  FETCH_EXTERNAL_TOKENS_SUCCESS: '@@externalToken/FETCH_EXTERNAL_TOKENS_SUCCESS',
  FETCH_EXTERNAL_TOKENS_FAILURE: '@@externalToken/FETCH_EXTERNAL_TOKENS_FAILURE',
  CREATE_OR_UPDATE_EXTERNAL_TOKEN: '@@externalToken/CREATE_OR_UPDATE_EXTERNAL_TOKEN',
  CREATE_OR_UPDATE_EXTERNAL_TOKEN_SUCCESS: '@@externalToken/CREATE_OR_UPDATE_EXTERNAL_TOKEN_SUCCESS',
  CREATE_OR_UPDATE_EXTERNAL_TOKEN_FAILURE: '@@externalToken/CREATE_OR_UPDATE_EXTERNAL_TOKEN_FAILURE',
  DELETE_EXTERNAL_TOKEN: '@@externalToken/DELETE_EXTERNAL_TOKEN',
  DELETE_EXTERNAL_TOKEN_SUCCESS: '@@externalToken/DELETE_EXTERNAL_TOKEN_SUCCESS',
  DELETE_EXTERNAL_TOKEN_FAILURE: '@@externalToken/DELETE_EXTERNAL_TOKEN_FAILURE',
}

export interface IExternalToken {
  readonly id: string
  readonly type: 'externalToken'
  readonly attributes: {
    readonly externalTokenUrl: string
    readonly expiresAt?: string | null
  }
}

export interface IExternalTokenState {
  readonly externalTokens: IExternalToken[]
  readonly loading: boolean
}

export interface IFetchExternalTokensPayload {
  readonly subtitleId: number
}

export interface ICreateOrUpdateExternalTokenPayload {
  readonly subtitleId: number
  readonly validityInDays: number
}

export interface IDeleteExternalTokenPayload {
  readonly subtitleId: number
  readonly externalTokenId: string
}

export interface ICreateOrUpdateExternalTokenSuccessResponseBody {
  readonly data: IExternalToken
}

export interface IFetchExternalTokensSuccessResponseBody {
  readonly data: IExternalToken[]
}

export type TExternalTokenActionTypes = IAction<ICreateOrUpdateExternalTokenSuccessResponseBody>
